import type { FilterObjectData } from '@app/components/CustomFilter';

import type { FiltersPayload, Locale } from './types';

export const mapFilterObjectToPayload = (filters: FilterObjectData[]): FiltersPayload[] =>
    filters.map(
        (filter): FiltersPayload =>
            ({
                relation: filter.operator?.toUpperCase() || 'AND',
                object: filter.field,
                option: filter.matcher,
                values: [filter.value],
            } as FiltersPayload),
    );

export const mapLocaleToSelectField = (locale: Locale) => ({ label: locale.name, value: locale.code });
